import React from 'react';
import GlobalBreadcrumbs from '../../components/global/GlobalBreadcrumbs';
import WrapperSection from '../../components/global/WrapperSection';
import FormAddEditJobTitle from '../../components/jobTitles/FormAddEditJobTitle';

const CreateJobTitle = () => (
    <WrapperSection>
        <GlobalBreadcrumbs />
        <FormAddEditJobTitle />
    </WrapperSection>
);

export default CreateJobTitle;
